<template>
  <div class="itinerary-section-item-actions">
    <div v-if="canBeFavorite" class="itinerary-section-item-actions__action">
      <button v-if="!changingFavorite" :disabled="actionButtonDisabled" @click="$emit('changing-favorite')">
        <TheHeartIcon :filled="isFavorite" />
      </button>
      <AppLoader v-else v-bind="loaderOptions" class="itinerary-section-item-actions__loader" />
    </div>

    <div v-if="canDetach" class="itinerary-section-item-actions__action">
      <button v-if="!isDetaching" @click="$emit('detaching-event')">
        <AppTrashIcon />
      </button>
      <AppLoader v-else v-bind="loaderOptions" class="itinerary-section-item-actions__loader" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    TheHeartIcon: () => import('@/components/icons/TheHeartIcon.vue'),
    AppTrashIcon: () => import('@/components/icons/AppTrashIcon.vue'),
  },
  props: {
    canBeFavorite: {
      type: Boolean,
      default: false,
    },
    canDetach: {
      type: Boolean,
      default: false,
    },
    changingFavorite: {
      type: Boolean,
      default: false,
    },
    isDetaching: {
      type: Boolean,
      default: false,
    },
    isFavorite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaderOptions: {
        borderWidth: 3,
        margin: 0,
        size: 20,
      },
    };
  },
  computed: {
    actionButtonDisabled() {
      return this.changingFavorite || this.isDetaching;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-section-item-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 10px;

  @media (min-width: vars.$mobile-break-point + 1px) {
    top: 16px;
    right: 16px;
    gap: 12px;
  }

  &__action {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    padding: 4px;
    background-color: vars.$c-total-white;
    border-radius: 50%;

    @media (min-width: vars.$mobile-break-point + 1px) {
      width: 40px;
      height: 40px;
    }

    button {
      padding: 0;
    }

    svg {
      width: 100%;
    }
  }

  &__loader {
    --app-itinerary-section-item-action-loader-size: 14px;

    @media (min-width: vars.$mobile-break-point + 1px) {
      --app-itinerary-section-item-action-loader-size: 20px;
    }

    width: var(--app-itinerary-section-item-action-loader-size);
    height: var(--app-itinerary-section-item-action-loader-size);

    ::v-deep {
      div {
        width: var(--app-itinerary-section-item-action-loader-size);
        height: var(--app-itinerary-section-item-action-loader-size);
        border-width: 2px;

        @media (min-width: vars.$mobile-break-point + 1px) {
          border-width: 3px;
        }
      }
    }
  }
}
</style>
